module.exports = __webpack_public_path__ + "static/media/us_1m.09058dae.avif";